import { useMemo } from 'react'
import { Organization } from '../../../types'
import { useData } from '../contexts/DataContextProvider'
import styles from './Multiples.module.scss'
import groupBy from 'lodash/groupBy'
import ScrollDownNotice from './ScrollDownNotice'
import MultiplesHeader from './MultiplesHeader'
import MultipleDotBars from './MultipleDotBars'
import { DEFAULT_LEGEND_ITEMS } from '../constants'

export default function StateByState() {
  const { data }: { data: Organization[] } = useData()

  const dataByState = useMemo(() => {
    const byState = groupBy(data, (org) => org.state || 'Unknown')
    return Object.entries(byState)
      .map(([state, orgs]) => ({
        name: state,
        orgs,
      }))
      .sort((a, b) => b.orgs.length - a.orgs.length)
      .filter(({ name }) => name !== 'Unknown')
  }, [data])

  return (
    <div className={styles.layout}>
      <MultiplesHeader
        title="State by State Breakdown"
        copy={[
          'The reparations movement is strong and growing, with communities all across the U.S. advancing reparations at the state and local level.',
        ]}
      />

      <MultipleDotBars
        dataByMultiple={dataByState}
        legendItems={DEFAULT_LEGEND_ITEMS}
      />

      <ScrollDownNotice />
    </div>
  )
}
